/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Button_Creating_CompanyInputs */

const es_co2_signup_button_creating_company = /** @type {(inputs: Signup_Button_Creating_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando empresa…`)
};

/**

* @param {Signup_Button_Creating_CompanyInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_button_creating_company = /** @type {((inputs?: Signup_Button_Creating_CompanyInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Button_Creating_CompanyInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_button_creating_company(inputs)
});